/** 全局 UI 状态 (侧边栏开合 / 主题等), 不持久化 */
import { create } from "zustand";

/** 与 Tailwind 的 md 断点一致: 小于 768px 视为手机布局 (侧边栏为浮层抽屉) */
export const MOBILE_QUERY = "(max-width: 767px)";

export function isMobileViewport(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    && window.matchMedia(MOBILE_QUERY).matches;
}

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebar: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  // 桌面默认展开; 手机默认收起 (点菜单按钮以抽屉形式打开)
  sidebarOpen: !isMobileViewport(),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebar: (open) => set({ sidebarOpen: open }),
}));
